



















































































import PartnerDetailAttributeWithToolTip from "@/components/partner/PartnerDetailAttributeWithToolTip.vue";
import { activityLogName } from "@/lib/utility/activityLogName";
import { detailedDate, simpleDate } from "@/lib/utility/date-helper";
import { SharingLinkFactory } from "@/lib/utility/sharingLinkFactory";
import DarkModeHighlightMixin from "@/mixins/DarkModeHighlightMixin.vue";
import {
  MrfiktivActivityLogViewModelGen,
  MrfiktivCreateSharedContentElementDtoGen,
  MrfiktivSharedContentViewmodelGen
} from "@/services/mrfiktiv/v1/data-contracts";
import { BackendResourceEnum } from "@/store/enum/authResourceEnum";
import { AttachmentRequestModule } from "@/store/modules/attachment-request.store";
import { SharedContentModule } from "@/store/modules/shared-content.store";
import SignInitializeDialog from "@/views/sign/SignInitializeDialog.vue";
import { Component, Prop } from "vue-property-decorator";
import ContextMenu from "../utility/ContextMenu.vue";
import TimelineCard from "../utility/TimelineItem.vue";
import ActivityTimeLineItemDelete from "./ActivityTimeLineItemDelete.vue";

@Component({
  components: {
    TimelineCard,
    PartnerDetailAttributeWithToolTip,
    SignInitializeDialog,
    ActivityTimeLineItemDelete,
    ContextMenu
  }
})
export default class ActivityTimeLineItemShareLink extends DarkModeHighlightMixin {
  @Prop({})
  activityLogEntry!: MrfiktivActivityLogViewModelGen;

  @Prop({ default: false })
  isEditable!: boolean;

  loading = false;
  loadingDeactivate = false;
  error = false;
  showMenu = false;

  get errorState() {
    return this.error;
  }

  get name() {
    return activityLogName(this.activityLogEntry);
  }

  sharedContents: MrfiktivSharedContentViewmodelGen[] = [];

  get headers() {
    return [{ value: "key" }, { value: "value" }];
  }

  toDetail(partnerId: string, id: string) {
    this.$router.push({ name: "SignRequestDetailView", params: { partnerId: partnerId, signRequestId: id } });
  }

  async mounted() {
    try {
      this.loading = true;
      if (this.activityLogEntry.target) {
        for (const sharedContent of this.activityLogEntry.target) {
          let found: MrfiktivSharedContentViewmodelGen;
          if (!this.isEditable) {
            found = await SharedContentModule.get({
              partnerId: this.activityLogEntry.partnerId,
              sharedContentId: sharedContent.refId
            });
          } else {
            found = await AttachmentRequestModule.get({
              partnerId: this.activityLogEntry.partnerId,
              attachmentId: sharedContent.refId
            });
          }

          if (found?.id) {
            this.sharedContents.push(found);
          } else {
            this.error = true;
          }
        }
      }
    } catch (error) {
      this.error = true;
      this.$log.error(error);
      this.error = true;
    }
    this.loading = false;
  }

  async deactivate() {
    this.loadingDeactivate = true;
    try {
      const data: MrfiktivCreateSharedContentElementDtoGen = {
        validBy: new Date(new Date().setDate(new Date().getDate() - 1)).toISOString(),
        refs: [
          {
            refType: this.sharedContents[0].refType as BackendResourceEnum,
            refId: this.sharedContents[0].refId ?? ""
          }
        ]
      };
      this.sharedContents[0] = await SharedContentModule.update({
        partnerId: this.sharedContents[0].partnerId,
        sharedContentId: this.sharedContents[0].id,
        data: data
      });
    } catch (error) {
      this.$log.error(error);
      this.$toast.error("Error deactivating Link.");
    }
    this.loadingDeactivate = false;
  }

  get title() {
    return this.$t("timeLine.ActivityTimeLineItemShare.validBy", { date: simpleDate(this.sharedContents[0].validBy) });
  }

  isActive() {
    if (this.sharedContents[0]) {
      return new Date(this.sharedContents[0].validBy).setHours(0, 0, 0, 0) >= new Date().setHours(0, 0, 0, 0);
    } else {
      return false;
    }
  }

  get date() {
    if (this.activityLogEntry.timestamp?.created) {
      const locale = this.$t("utility.toLocalDateString").toString() || "de-de";
      return detailedDate(this.activityLogEntry.timestamp?.created, locale);
    }
    return this.$t("sign.DocumentDetail.noDate");
  }

  copyLinkToClipboard() {
    const sharingLinkFactory = new SharingLinkFactory(this.sharedContents[0], this.isEditable);
    try {
      sharingLinkFactory.copyLinkToClipboard();
      this.$toast.info(this.$t("components.partner.PartnerReportInitializeCard.linkCopied"));
    } catch (error) {
      this.$toast.error(this.$t("components.partner.PartnerReportInitializeCard.error"));
    }
  }
}
